(function(){
    const atcButton = document.querySelector('.product-form__quantity-and-btn');
    const atcPrice = atcButton?.querySelector('.main-atc-price span[class*="main-atc-price"]');
    const productForm = atcButton?.closest('product-info')

    if (!atcPrice || !productForm) return;


  window.addEventListener('stay-ai-subscription-changed', (event) => {
    setTimeout(() => {
      const stayWidget = productForm.querySelector('.stayai-widget');
      if (!stayWidget) return
  
      const otpPrice = stayWidget.querySelector('[data-stayai-onetime-price]');
      const subPrice = stayWidget.querySelector('[data-stayai-subscription-price]');
          
      atcPrice.textContent = event.detail.sellingPlanId ? subPrice.textContent.replace(otpPrice.textContent, '') : otpPrice.textContent
    }, 80);
  })
})();